import {
  PaywallSource,
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';
import { SubscriptionTier } from '@heidi/schema/ml-scribe';

export function paywallCheckoutClickedFromFreeToPaid() {
  trackLegacyEvent({
    name: SegmentObjectName.Paywall,
    props: {
      action: SegmentActionName.PaywallCheckoutClickedFromFreeToPaid,
      target_plan: SubscriptionTier.PRO,
      // [4/5] getSegmentContext() removed with the model's state; it was
      // provably always undefined (setSegmentContext had zero dispatchers).
      paywall_context: undefined,
    },
  });

  // V2 — paywall_viewed
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.PaywallViewed,
    props: {
      source: PaywallSource.AccountToPro,
      target_plan: SubscriptionTier.PRO,
    },
  });
}

export function paywallModalOpenFromExtendProTrial() {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.PaywallViewed,
    props: {
      source: PaywallSource.ExtendProTrial,
      target_plan: SubscriptionTier.PRO,
    },
  });
}

export function paywallModalOpenFromSessionHeader() {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.PaywallViewed,
    props: {
      source: PaywallSource.SessionHeader,
      target_plan: SubscriptionTier.PRO,
    },
  });
}

export function paywallModalOpenFromSidebar() {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.PaywallViewed,
    props: {
      source: PaywallSource.Sidebar,
      target_plan: SubscriptionTier.PRO,
    },
  });
}
